import { Component, OnInit } from '@angular/core';
import { Notice } from '@app/shared/models/notices.model';
import { NoticesService } from '@app/shared/services/notices.service';

@Component({
  selector: 'ty-notices',
  templateUrl: './notices.component.html',
  styleUrls: ['./notices.component.scss'],
})
export class NoticesComponent implements OnInit {

  public notices!: Notice[];

  constructor( private noticesService: NoticesService ) {}

  ngOnInit(): void {
    this.getNotices();
  }

  getNotices(): void {
    // this.noticesService.getNotices()
    //   .subscribe( notices => this.notices = notices);
    this.notices = [{
      "IdAviso": 1,
      "IdEmpresa": 2,
      "CConces": 400,
      "Codlinea": "401",
      "Tipo": "I",
      "Texto": "Demo AVISO LARGO AVISO LARGO AVISO LARGO"
    },
    {
      "IdAviso": 4,
      "IdEmpresa": 2,
      "CConces": 300,
      "Codlinea": "123",
      "Tipo": "II",
      "Texto": "Demo Aviso"
    },
    {
      "IdAviso": 3,
      "IdEmpresa": 5,
      "CConces": 232,
      "Codlinea": "11",
      "Tipo": "I",
      "Texto": "Demo AVSA"
    }
  ]
  }

}
